import Vue from "vue";

// Components
import YZbLUcRUForm from "@Landing_YZbLUcRU/Scripts/Components/YZbLUcRUForm/YZbLUcRUForm.vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-yzblucruform", YZbLUcRUForm);
        Vue.component("app-cookietoast", CookieToast);
    }

    public static AddDirectives() { }
}